export const options = [
  {
    title: "view",
    icon: "mdi-view-headline",
    click: "showScheduleForm=true",
  },
  { title: "update", icon: "mdi-pencil", click: "showScheduleForm=true" },
  {
    title: "move",
    icon: "mdi-map-marker-radius-outline",
    click: "showScheduleForm=true",
  },
  {
    title: "delete",
    icon: "mdi-account-remove",
    click: "showScheduleForm=true",
  },
];
export const towOptions = [
  { title: "update", icon: "mdi-pencil", click: "showScheduleForm=true" },
  {
    title: "delete",
    icon: "mdi-trash-can",
    click: "showScheduleForm=true",
  },
];
export const jobHistoryOptions = [
  // {
  //   title: "changeDepartment",
  //   icon: "mdi-map-marker-outline",
  //   click: "showScheduleForm=true",
  // },
  {
    title: "finishJob",
    icon: "mdi-trash-can",
    click: "showScheduleForm=true",
  },
];
export const threeOptions = [
  {
    title: "view",
    icon: "mdi-view-headline",
    click: "showScheduleForm=true",
  },
  { title: "update", icon: "mdi-pencil", click: "showScheduleForm=true" },
  {
    title: "delete",
    icon: "mdi-trash-can",
    click: "showScheduleForm=true",
  },
];
export const pendingList = [
  {
    title: "approve",
    icon: "mdi-view-headline",
    click: "showScheduleForm=true",
  },
  { title: "update", icon: "mdi-pencil", click: "showScheduleForm=true" },
  {
    title: "delete",
    icon: "mdi-trash-can",
    click: "showScheduleForm=true",
  },
  { title: "changeStatus", icon: "mdi-pencil", click: "showScheduleForm=true" },
];
export const inProgressList = [
  {
    title: "extend",
    icon: "mdi-view-headline",
    click: "showScheduleForm=true",
  },
  { title: "cut", icon: "mdi-pencil", click: "showScheduleForm=true" },
  { title: "changeStatus", icon: "mdi-pencil", click: "showScheduleForm=true" },
];
export const oneOptions = [
  {
    title: "delete",
    icon: "mdi-trash-can",
    click: "showScheduleForm=true",
  },
];
export const shiftOptions = [
  {
    title: "employeesShifts",
    icon: "mdi-view-headline",
    click: "showScheduleForm=true",
  },
  { title: "update", icon: "mdi-pencil", click: "showScheduleForm=true" },
  {
    title: "delete",
    icon: "mdi-trash-can",
    click: "showScheduleForm=true",
  },
];
export const fourOptions = [
  {
    title: "view",
    icon: "mdi-view-headline",
    click: "showScheduleForm=true",
  },
  { title: "update", icon: "mdi-pencil", click: "showScheduleForm=true" },
  {
    title: "delete",
    icon: "mdi-account-remove",
    click: "showScheduleForm=true",
  },
  {
    title: "viewHistory",
    icon: "mdi-clipboard-text-clock",
    click: "showScheduleForm=true",
  },
];
export const viewDeleteOptions = [
  {
    title: "view",
    icon: "mdi-view-headline",
    click: "showScheduleForm=true",
  },
  {
    title: "delete",
    icon: "mdi-trash-can",
    click: "showScheduleForm=true",
  },
];
export const salaryTableOptions = [
  {
    title: "view",
    icon: "mdi-view-headline",
    click: "showScheduleForm=true",
  },
  {
    title: "confirmPaid",
    icon: "mdi-check-underline",
    click: "showScheduleForm=true",
  },
  {
    title: "delete",
    icon: "mdi-trash-can",
    click: "showScheduleForm=true",
  },
];

export const employeeSideBar = [
  { title: "employees", icon: "mdi-account-multiple", id: 0, link: "/home" },
  {
    title: "staffEvaluation",
    icon: "mdi-account-star-outline",
    id: 1,
    link: "/EmployeeReviews",
  },
  {
    title: "directorates",
    icon: "mdi-file-multiple-outline",
    id: 7,
    link: "/directorates",
  },
  {
    title: "departments",
    icon: "mdi-bank",
    id: 2,
    link: "/Departments",
  },
  {
    title: "recruitment",
    icon: "mdi-account-plus-outline",
    id: 3,
    link: "/Jobs",
  },
  {
    title: "Courses",
    icon: "mdi-account-minus-outline",
    id: 4,
    link: "/Courses",
  },
  {
    title: "trainingLog",
    icon: "mdi-check-decagram",
    id: 6,
    link: "/TrainingHistory",
  },
];
export const userSidebar = [
  {
    title: "users",
    icon: "mdi-account-multiple-outline",
    id: 0,
    link: "/users",
  },
  {
    title: "roles and permissions",
    icon: "mdi-shield-account-variant-outline",
    id: 1,
    link: "/rolesList",
  },
];
export const attendanceSideBar = [
  {
    title: "employeesAttendance",
    icon: "mdi-account-group-outline",
    id: 1,
    link: "/Attendance",
  },
  {
    title: "WorkTime",
    icon: "mdi-file-check-outline",
    id: 2,
    link: "/AttendanceTemplates",
  },
  {
    title: "holidays",
    icon: "mdi-file-remove-outline",
    id: 3,
    link: "/Holidays",
  },
  {
    title: "shifts",
    icon: "mdi-file-question-outline",
    id: 4,
    link: "/Shifts",
  },
];
export const locationsSideBar = [
  {
    title: "location",
    icon: "mdi-map-marker-outline",
    id: 0,
    link: "/location",
  },
];

export const taskManagerSideBar = [
  {
    title: "projects",
    icon: "mdi-folder-open-outline",
    id: 0,
    link: "/taskManager",
  },
  {
    title: "tasks",
    icon: "mdi-file-multiple-outline",
    id: 0,
    link: "/tasks",
  },
];
export const Statistics = [
  { title: "all", value: "20" },
  { title: "notActive", value: "0" },
  { title: "terminated", value: "0" },
  { title: "resigned", value: "0" },
  { title: "Deleted", value: "0" },
];

export const LocationStatistics = [
  { title: "all", value: "20" },
  { title: "countries", value: "0" },
  { title: "cities", value: "0" },
  { title: "locations", value: "0" },
];
export const UserStatistics = [
  { title: "all", value: "20" },
  { title: "inactive", value: "0" },
  { title: "dismissed", value: "0" },
  { title: "resigned", value: "0" },
  { title: "deleted", value: "0" },
];

export const LeaveStatistics = [
  { title: "all", value: "20" },
  { title: "inactive", value: "0" },
  { title: "dismissed", value: "0" },
  { title: "resigned", value: "0" },
  { title: "deleted", value: "0" },
];
export const salaryStatistics = [
  { title: "all employees", value: "20" },
  { title: "salariesSum", value: "0" },
  { title: "totalPaid", value: "0" },
  { title: "totalUnpaid", value: "0" },
  //{ title: "deleted", value: "0" },
];

export const links = [
  { name: "HR", src: "/home" },
  { name: "attendance", src: "/Attendance" },
  { name: "location", src: "/location" },
  { name: "salarys", src: "/salaries" },
  // { name: "tasks", src: "/taskManager" },
  { name: "leaves", src: "/leaves" },
  // { name: "opportunities", src: "/opportunities" },
  { name: "users", src: "/users" },
];

export const payment = [
  { name: "monthly", selected: false },
  { name: "weekly", selected: false },
  { name: "daily", selected: false },
];
export const active = [
  { name: "active", selected: false },
  { name: "notActive", selected: false },
];
export const work = [
  { name: "fullTime", selected: false },
  { name: "partTime", selected: false },
  { name: "contract", selected: false },
];
export const headersReview = [
  {
    text: "employeeName",
    value: "employee",
    sortable: true,
    class: "firstTh",
  },
  {
    text: "reviewFactor",
    value: "date_of_review",
    class: "restTh",
    sortable: false,
  },
  {
    text: "reviwedBy",
    value: "reviewed_by_employee",
    class: "restTh",
    sortable: false,
  },
  { text: "rating", value: "review_details", class: "restTh", sortable: false },
  { text: "date", value: "date", class: "restTh", sortable: false },
  { text: "", value: "", class: "restTh", sortable: false },
];
export const heaersDep = [
  {
    text: "department",
    value: "name",
    sortable: true,
    class: "firstTh d-table-cell",
  },
  {
    text: "site",
    value: "location_street_address",
    class: "restTh",
    sortable: false,
  },
  { text: "manger", value: "manager", class: "restTh", sortable: false },
  {
    text: "directorate",
    value: "directorate",
    class: "restTh",
    sortable: false,
  },
  {
    text: "",
    value: "",
    class: "restTh",
    sortable: false,
  },
];

export const headersTasks = [
  {
    text: "task",
    value: "task",
    sortable: true,
    class: "firstTh",
  },
  {
    text: "project",
    value: "project",
    class: "restTh",
    sortable: false,
  },
  {
    text: "description",
    value: "description",
    class: "restTh",
    sortable: false,
  },
  {
    text: "status",
    value: "status",
    class: "restTh",
    sortable: false,
  },
  {
    text: "",
    value: "",
    class: "restTh",
    sortable: false,
  },
];
export const headersCourse = [
  {
    text: "courseName",
    value: "name",
    sortable: false,
    class: "firstTh",
  },
  // {
  //   text: "courseDescription",
  //   value: "description",
  //   class: "restTh",
  //   sortable: false,
  // },
  {
    text: "internalORexternal",
    value: "internalORexternal",
    class: "restTh",
    sortable: false,
  },
  {
    text: "courseContent",
    value: "course_domain",
    class: "restTh",
    sortable: false,
  },

  // {
  //   text: "estimatedCost",
  //   value: "estimated_cost",
  //   class: "restTh",
  //   sortable: false,
  // },
  // {
  //   text: "realCost",
  //   value: "real_cost",
  //   class: "restTh",
  //   sortable: false,
  // },
  {
    text: "courseType",
    value: "type",
    class: "restTh",
    sortable: false,
  },
  // {
  //   text: "trainerName",
  //   value: "trainer_name",
  //   class: "restTh",
  //   sortable: false,
  // },
  // {
  //   text: "trainingCompany",
  //   value: "trainer_company",
  //   class: "restTh",
  //   sortable: false,
  // },
  // {
  //   text: "startDate",
  //   value: "start_date",
  //   class: "restTh",
  //   sortable: false,
  // },
  // {
  //   text: "endDate",
  //   value: "end_date",
  //   class: "restTh",
  //   sortable: false,
  // },
  { text: "status", value: "course_domain", class: "restTh", sortable: false },
  { text: "", value: "", class: "restTh", sortable: false },
];
export const headersDirectorates = [
  {
    text: "directorates",
    value: "name",
    sortable: false,
    class: "firstTh",
  },
  {
    text: "location",
    value: "location",
    sortable: false,
    class: "restTh",
  },
  {
    text: "managerDepartment",
    value: "manager",
    sortable: false,
    class: "restTh",
  },
  {
    text: "",
    value: "",
    sortable: false,
    class: "restTh",
  },
];
export const headersJob = [
  {
    text: "position",
    value: "title",
    sortable: true,
    class: "firstTh",
  },
  // { text: "department", value: "date", class: "restTh", sortable: false },
  { text: "maxSalary", value: "max_salary", class: "restTh", sortable: false },
  { text: "minSalary", value: "min_salary", class: "restTh", sortable: false },
  // {
  //   text: "description",
  //   value: "description",
  //   class: "restTh",
  //   sortable: false,
  // },
  {
    text: "department",
    value: "department_id",
    class: "restTh",
    sortable: false,
  },
  // {
  //   text: "responsibilities",
  //   value: "responsiblities",
  //   class: "restTh",
  //   sortable: false,
  // },
  // {
  //   text: "required skills",
  //   value: "required_skills",
  //   class: "restTh",
  //   sortable: false,
  // },
  // {
  //   text: "qualifications",
  //   value: "qualification",
  //   class: "restTh",
  //   sortable: false,
  // },
  // {
  //   text: "required docs",
  //   value: "required_docs",
  //   class: "restTh",
  //   sortable: false,
  // },
  {
    text: "total employees",
    value: "total_employees",
    class: "restTh",
    sortable: false,
  },
  { text: "", value: "", class: "restTh", sortable: false },
];
export const headersTrainingHistory = [
  {
    text: "employeeName",
    value: "employee",
    sortable: true,
    class: "firstTh",
  },
  { text: "courseName", value: "courseName", class: "restTh", sortable: false },
  { text: "startDate", value: "startDate", class: "restTh", sortable: false },
  { text: "endDate", value: "endDate", class: "restTh", sortable: false },
  { text: "type", value: "type", class: "restTh", sortable: false },
  { text: "result", value: "by", class: "restTh", sortable: false },
  {
    text: "",
    value: "",
    class: "restTh",
    sortable: false,
  },
];
export const headersJobHistory = [
  {
    text: "employeeName",
    value: "employee",
    sortable: true,
    class: "firstTh",
  },
  { text: "job", value: "job", class: "restTh", sortable: false },
  {
    text: "department",
    value: "department",
    class: "restTh",
    sortable: false,
  },
  { text: "manager", value: "description", class: "restTh", sortable: false },
  { text: "BaseSalary", value: "baseSalary", class: "restTh", sortable: false },
  {
    text: "VirtualSalary",
    value: "virtualSalary",
    class: "restTh",
    sortable: false,
  },
  { text: "startDate", value: "start_date", class: "restTh", sortable: false },
  { text: "endJobDate", value: "end_date", class: "restTh", sortable: false },
  {
    text: "",
    value: "",
    class: "restTh",
    sortable: false,
  },
];
export const headersEmployees = [
  {
    text: "employeeName",
    value: "name",
    class: "firstTh",
    sortable: false,
  },
  {
    text: "jobDescription",
    value: "jobDescription",
    class: "restTh",
    sortable: false,
  },
  {
    text: "department",
    value: "department",
    class: "restTh",
    sortable: false,
  },
  {
    text: "birthday",
    value: "birthday",
    class: "restTh",
    sortable: false,
  },
  {
    text: "job_date",
    value: "job_date",
    class: "restTh",
    sortable: false,
  },
  {
    text: "",
    value: "",
    class: "restTh",
    sortable: false,
  },
];

export const headersLocation = [
  {
    text: "country",
    value: "country",
    class: "firstTh",
    sortable: true,
  },
  {
    text: "city",
    value: "city",
    class: "restTh",
    sortable: false,
  },
  {
    text: "location",
    value: "location",
    class: "restTh",
    sortable: false,
  },
  {
    text: "",
    value: "",
    class: "restTh",
    sortable: false,
  },
];
export const rolesHeaders = [
  {
    text: "role",
    value: "role",
    class: "firstTh",
    sortable: false,
  },
  {
    text: "",
    value: "",
    class: "restTh",
  },
];
export const headersUsers = [
  {
    text: "username",
    value: "username",
    class: "firstTh",
    sortable: true,
  },
  {
    text: "email",
    value: "email",
    class: "restTh",
    sortable: false,
  },
  {
    text: "status",
    value: "status",
    class: "restTh",
    sortable: false,
  },
  {
    text: "",
    value: "",
    class: "restTh",
    sortable: false,
  },
];

export const headersLeaves = [
  {
    text: "employee",
    value: "employee",
    class: "firstTh",
    sortable: true,
  },
  {
    text: "leaveType",
    value: "leaveType",
    class: "restTh",
    sortable: false,
  },
  {
    text: "from",
    value: "from",
    class: "restTh",
    sortable: false,
  },
  {
    text: "to",
    value: "to",
    class: "restTh",
    sortable: false,
  },
  {
    text: "status",
    value: "status",
    class: "restTh",
    sortable: false,
  },
  {
    text: "interruptDate",
    value: "interruptDate",
    class: "restTh",
    sortable: false,
  },
  {
    text: "leaveReason",
    value: "leaveReason",
    class: "restTh",
    sortable: false,
  },
  {
    text: "",
    value: "",
    class: "restTh",
    sortable: false,
  },
];

export const headersProjects = [
  {
    text: "projects",
    value: "projects",
    class: "firstTh",
    sortable: true,
  },
  {
    text: "description",
    value: "description",
    class: "restTh",
    sortable: false,
  },
  {
    text: "status",
    value: "status",
    class: "restTh",
    sortable: false,
  },
  {
    text: "",
    value: "",
    class: "restTh",
    sortable: false,
  },
];

export const courseLocations = [
  { text: "in-company" },
  { text: "out-company" },
  { text: "out-country" },
];
export const avatarMenu = [
  { title: "settings", image: "settings.svg", src: "/settings" },
  { title: "logout", image: "logout.svg", src: "", action: "loggingOut" },
];
export const headersAttendance = [
  {
    text: "employeeName",
    value: "employee",
    sortable: true,
    class: "firstTh",
  },
  {
    text: "attendanceDate",
    value: "datetime",
    class: "restTh",
    sortable: false,
  },
  {
    text: "hour",
    value: "hour",
    class: "restTh",
    sortable: false,
  },
  {
    text: "attendanceType",
    value: "inORout",
    class: "restTh",
    sortable: false,
  },
  {
    text: "",
    value: "",
    class: "restTh",
    sortable: false,
  },
];
export const headersAttendanceTemplates = [
  {
    text: "workType",
    value: "name",
    sortable: true,
    class: "firstTh",
  },
  {
    text: "workDescription",
    value: "description",
    class: "restTh",
    sortable: false,
  },
  {
    text: "status",
    value: "isActive",
    class: "restTh",
    sortable: false,
  },
  {
    text: "",
    value: "",
    class: "restTh",
    sortable: false,
  },
];
export const headersHolidays = [
  {
    text: "holidays",
    value: "name",
    sortable: true,
    class: "firstTh",
  },
  {
    text: "date",
    value: "date",
    class: "restTh",
    sortable: false,
  },
  // {
  //   text: "status",
  //   value: "isActive",
  //   class: "restTh",
  //   sortable: false,
  // },
  {
    text: "",
    value: "",
    class: "restTh",
    sortable: false,
  },
];
export const headersShifts = [
  {
    text: "shift",
    value: "name",
    sortable: true,
    class: "firstTh",
  },
  {
    text: "workType",
    value: "name",
    sortable: true,
    class: "firstTh",
  },
  {
    text: "from",
    value: "from",
    class: "restTh",
    sortable: false,
  },
  {
    text: "to",
    value: "to",
    class: "restTh",
    sortable: false,
  },
  {
    text: "break",
    value: "break",
    class: "restTh",
    sortable: false,
  },
  {
    text: "WorkTime",
    value: "week_days",
    class: "restTh",
    sortable: false,
  },
  {
    text: "",
    value: "",
    class: "restTh",
    sortable: false,
  },
];
export const headersPaidWage = [
  {
    text: "employeeName",
    value: "employee",
    sortable: true,
    class: "firstTh",
  },
  { text: "wageType", value: "wageType", class: "restTh", sortable: false },
  {
    text: "salary",
    value: "amount",
    sortable: false,
    class: "firstTh",
  },
  {
    text: "wage",
    value: "yes",
    sortable: false,
    class: "firstTh",
  },
  { text: "date", value: "date", class: "restTh", sortable: false },
  {
    text: "",
    value: "",
    sortable: false,
    class: "firstTh",
  },
];
export const headersEmployeeWage = [
  {
    text: "employeeName",
    value: "employee",
    sortable: true,
    class: "firstTh",
  },
  { text: "wageType", value: "wageType", class: "restTh", sortable: false },
  {
    text: "salary",
    value: "amount",
    sortable: false,
    class: "firstTh",
  },
  {
    text: "",
    value: "",
    sortable: false,
    class: "firstTh",
  },
  {
    text: "",
    value: "",
    sortable: false,
    class: "firstTh",
  },
];
export const activeOrNotActive = [
  { text: "active", value: "0" },
  { text: "notActive", value: "1" },
];
export const anyOrAll = [
  { text: "any", value: "any" },
  { text: "allConditions", value: "all" },
];
export const days = [
  { text: "saturday" },
  { text: "sunday" },
  { text: "monday" },
  { text: "tuesday" },
  { text: "wednesday" },
  { text: "thursday" },
  { text: "friday" },
];
export const inORout = [
  { text: "inside", value: 1 },
  { text: "out", value: 0 },
];
export const rpType = [
  { text: "reward", value: "reward" },
  { text: "penalty", value: "penalty" },
];
export const rpValueType = [
  { text: "percentage", value: "percentage" },
  { text: "net_value", value: "net_value" },
];
export const calculatedFrom = [
  { text: "BaseSalary", value: "BaseSalary" },
  { text: "VirtualSalary", value: "VirtualSalary" },
];
export const statuses = [
  { name: "active", id: 1 },
  { name: "blocked", id: 2 },
];

export const projectStatuses = [
  { name: "toDo", id: 1 },
  { name: "inProgress", id: 2 },
  { name: "done", id: 3 },
  { name: "programming", id: 4 },
  { name: "analysis", id: 5 },
];
export const headersEmpShifts = [
  {
    text: "name",
    value: "name",
    sortable: true,
    class: "firstTh",
  },
  {
    text: "jobDescription",
    value: "job_description",
    class: "restTh",
    sortable: false,
  },
  {
    text: "status",
    value: "status",
    class: "restTh",
    sortable: false,
  },
  {
    text: "",
    value: "",
    class: "restTh",
    sortable: false,
  },
];
export const payrollSideBar = [
  // {
  //   title: "rewards",
  //   icon: "mdi-trophy",
  //   id: 0,
  //   link: "/employee-rptypes",
  // },
  // {
  //   title: "penalties",
  //   icon: "mdi-close-box-outline",
  //   id: 0,
  //   link: "/employee-rptypes-penalties",
  // },
  // {
  //   title: "staffWages",
  //   icon: "mdi-account-star-outline",
  //   id: 1,
  //   link: "/employee-Wages",
  // },
  // {
  //   title: "paidWages",
  //   icon: "mdi-account-multiple-check",
  //   id: 2,
  //   link: "/paidWages",
  // },
  {
    title: "salarys",
    icon: "mdi-cash-multiple",
    id: 3,
    link: "/salaries",
  },
];
export const headersPayRoll = [
  {
    text: "name",
    value: "name",
    sortable: true,
    class: "firstTh",
  },
  {
    text: "rpType",
    value: "rpType",
    sortable: true,
    class: "firstTh",
  },
  {
    text: "rewardsAndPenalties",
    value: "type",
    class: "restTh",
    sortable: false,
  },
  {
    text: "valueType",
    value: "value_type",
    class: "restTh",
    sortable: false,
  },
  {
    text: "hasTax",
    value: "hasTax",
    class: "restTh",
    sortable: false,
  },
  {
    text: "value",
    value: "value",
    class: "restTh",
    sortable: false,
  },
  {
    text: "",
    value: "",
    class: "restTh",
    sortable: false,
  },
];
export const Salaries = [
  {
    text: "name",
    value: "name",
    sortable: true,
    class: "firstTh",
  },
  {
    text: "baseSalary",
    value: "baseSalary",
    class: "restTh",
    sortable: false,
  },
  {
    text: "VirtualSalary",
    value: "virtualSalary",
    class: "restTh",
    sortable: false,
  },
  {
    text: "incomeTax",
    value: "incomeTax",
    class: "restTh",
    sortable: false,
  },
  {
    text: "totalRewards",
    value: "totalRewards",
    class: "restTh",
    sortable: false,
  },
  {
    text: "totalPenelties",
    value: "totalPenelties",
    class: "restTh",
    sortable: false,
  },
  {
    text: "finalSalary",
    value: "finalSalary",
    class: "restTh",
    sortable: false,
  },
  {
    text: "isPaid",
    value: "isPaid",
    class: "restTh",
    sortable: false,
  },
  {
    text: "yearAndMonth",
    value: "yearAndMonth",
    class: "restTh",
    sortable: false,
  },
  {
    text: "",
    value: "",
    class: "restTh",
    sortable: false,
  },
];
export const rpTypesHeaders = [
  {
    text: "name",
    value: "name",
    sortable: true,
    class: "firstTh",
  },
  {
    text: "type",
    value: "type",
    class: "restTh",
    sortable: false,
  },
  {
    text: "value",
    value: "value",
    class: "restTh",
    sortable: false,
  },
  {
    text: "basedOn",
    value: "basedOnSalary",
    class: "restTh",
    sortable: false,
  },
  {
    text: "hasTax",
    value: "hasTax",
    class: "restTh",
    sortable: false,
  },
  {
    text: "action",
    value: "",
    class: "restTh",
    sortable: false,
  },
];

export const rewardsOrPenalties = [
  {
    text: "penalty",
    value: "penalty",
  },
  {
    text: "reward",
    value: "reward",
  },
];
export const valueType = [
  {
    text: "percent",
    value: "percent",
  },
  {
    text: "netSalary",
    value: "netSalary",
  },
];
export const conditionsHeaders = [
  {
    text: "table",
    value: "table",
  },
  {
    text: "field",
    value: "field",
  },
  {
    text: "rule",
    value: "rule",
  },
  {
    text: "value",
    value: "value",
  },
  {
    text: "operation",
    value: "operation",
  },
  {
    text: "actions",
    value: "",
  },
];
export const WageType = [
  { text: "daily", value: "daily" },
  { text: "weekly", value: "weekly" },
];
export const SettingsSidebar = [
  {
    title: "rewardsAndPenalties",
    icon: "mdi-trophy",
    id: 0,
    link: "/settings",
    underline: false,
  },
  {
    title: "taxSlices",
    icon: "",
    id: 0,
    link: "/settings/taxSlices",
    underline: true,
  },
  {
    title: "trainingLog",
    icon: "mdi-content-copy",
    id: 0,
    link: "/settings/trainingSetting",
    underline: true,
  },
  {
    title: "courseContent",
    icon: "mdi-account-star",
    id: 0,
    link: "/settings/coursesDomains",
    underline: true,
  },
  {
    title: "staffEvaluation",
    icon: "mdi-account-star",
    id: 0,
    link: "/settings/empReveiwsSetting",
    underline: true,
  },
  {
    title: "vacations",
    icon: "mdi-account-minus",
    id: 0,
    link: "/settings/vacations",
    underline: true,
  },
  {
    title: "countries",
    icon: "mdi-account-star",
    id: 0,
    link: "/settings/countries",
    underline: false,
  },
  {
    title: "cities",
    icon: "",
    id: 0,
    link: "/settings/cities",
    underline: true,
  },
  {
    title: "skills",
    icon: "mdi-account-check",
    id: 0,
    link: "/settings/skills",
    underline: false,
  },
  {
    title: "skillLevels",
    icon: "",
    id: 0,
    link: "/settings/skillsLevels",
    underline: true,
  },
  {
    title: "rules",
    icon: "mdi-account-check",
    id: 0,
    link: "/settings/rules",
    underline: false,
  },
  {
    title: "conditions",
    icon: "",
    id: 0,
    link: "/settings/conditions",
    underline: false,
  },
];
